import {useState, useEffect} from 'react'
import * as d3 from 'd3'

export const useWorldAtlas = () => {
 const [data, setData] = useState(null)

 const url = 'https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json'

useEffect(() => {
d3.json(url).then(data => setData(data))
},[])
 

 return data
}